$(document).ready(function () {


	/*-----MENU DROPDOWN-----*/

	$('.menu-link ul li:has(ul)').addClass("haschild");
	var caicon = $('<i class="fa fa-angle-down menudrop" aria-hidden="true"></i>');
	$('.menu-link ul li:has(ul) > a').append(caicon);
	$('.menu-link ul li:has(ul) > a').next().addClass("childmenu");




 if (($(window).width() <= 1199)) {
			$('.menudrop').on('click', function (e) {
			var label = $(this).parent();
			var parent = label.parent('.haschild');
			var list = label.siblings('.childmenu');
			e.preventDefault();
			if (parent.hasClass('isopen')) {
				list.slideUp('fast');
				parent.removeClass('isopen');
			} else {
				parent.parent().find('li.haschild').removeClass('isopen');
				parent.parent().find('li.haschild .childmenu').slideUp(350);
				list.slideDown('fast');
				parent.addClass('isopen');
			}
		});
	} 
	else 
	{
			$('.menudrop').on('click', function (e) {
				e.preventDefault();
				var label = $(this).parent();
				var parent = label.parent('.haschild');
				var list = label.siblings('.childmenu');
				if (parent.hasClass('isopen')) {
						list.hide();
						parent.removeClass('isopen');
						$('body').removeClass("menuoverlay");
				} 
			else 
				{
						parent.parent().find('li.haschild').removeClass('isopen');
						label.parent().parent().find("li .childmenu").hide();
						parent.addClass('isopen');
						label.parent().parent().find("li.isopen .childmenu").show();
						$('body').addClass("menuoverlay");
			}
		});
	}

	$('li.has-sub').hover(
			function () {
				$('body').addClass('menuoverlay');
			},
			function () {
				$('body').removeClass('menuoverlay');
			}
	);
	
	/*-----BURGER MENU-----*/
	$(".togglebtn, .overlay").click(function () {
		$(".togglebtn, .overlay,.menu-link").toggleClass("active");
		if ($(".overlay").hasClass("active")) {
			$(".overlay").fadeIn();
			$('html').addClass('menuhidden');

		} else {
			$(".overlay").fadeOut();
			$('html').removeClass('menuhidden');

		}
	});



	/*-----FIXED HEADER-----*/

	$(window).scroll(function () {
		if (($(window).scrollTop() > 180) && ($(window).width() >= 300)) {
			$('body').addClass('fixed-header');
		} else {
			$('body').removeClass('fixed-header');
		}
	});

  if ($(window).width() > 1199) {
    /* left right auto set menu */
    function adjustMegaMenu($parent) {
      var $child_menu = $parent.children('.sub-menu');

      if ($child_menu.length) {
        // Reset before calculation
        $child_menu.css({
          "left": "",
          "right": ""
        });

        // Viewport boundaries with 200px padding
        var viewportLeft = 200;
        var viewportRight = $(window).width() - 200;

        // Menu info
        var parentLeft = $parent.offset().left;
        var parentWidth = $parent.outerWidth();
        var menuWidth = $child_menu.outerWidth();
        var menuLeftPos = parentLeft;
        var menuRightPos = parentLeft + menuWidth;

        // --- Decide alignment ---
        if (menuRightPos <= viewportRight) {
          // Fits on the right side → align left
          $child_menu.css({
            "left": "0",
            "right": "auto"
          });
        } else if (parentLeft + parentWidth - menuWidth >= viewportLeft) {
          // Fits on the left side → align right
          $child_menu.css({
            "right": "0",
            "left": "auto"
          });
        } else {
          // If it overflows on both sides, pin it inside safe zone
          var safeLeft = viewportLeft - parentLeft;
          $child_menu.css({
            "left": safeLeft + "px",
            "right": "auto"
          });
        }
      }
    }

    // Run on hover
    $(".menu-link > nav > ul > li").on("mouseenter", function() {
      adjustMegaMenu($(this));
    });

    // Recheck on window resize
    $(window).on("resize", function() {
      $(".menu-link > nav > ul > li").each(function() {
        adjustMegaMenu($(this));
      });
    });
  }


});